import { __ } from "@wordpress/i18n";
import { useBlockProps } from "@wordpress/block-editor";

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @return {Element} Element to render.
 */
export default function save(props) {
	const { attributes } = props;

	const countDownStyle = {
		"--wpopus-count-down-width": `${attributes.countDownWidth}px`,
		"--wpopus-count-down-height": `${attributes.countDownHeight}px`,
		"--wpopus-count-down-border": `${attributes.countDownBorder.width} ${attributes.countDownBorder.style} ${attributes.countDownBorder.color}`,
		"--wpopus-count-down-border-radius": `${attributes.countDownBorderRadius}px`,
		"--wpopus-count-down-bg-color": `${attributes.countDownBgColor}`,
		"--wpopus-count-down-number-font": `${attributes.options.numberFontFamily}`,
		"--wpopus-count-down-number-font-size": `${attributes.options.numberFontSize}`,
		"--wpopus-count-down-number-font-weight": `${attributes.options.numberFontWeight}`,
		"--wpopus-count-down-number-font-color": `${attributes.options.numberFontColor}`,
		"--wpopus-count-down-label-font": `${attributes.options.labelFontFamily}`,
		"--wpopus-count-down-label-font-size": `${attributes.options.labelFontSize}`,
		"--wpopus-count-down-label-font-weight": `${attributes.options.labelFontWeight}`,
		"--wpopus-count-down-label-font-color": `${attributes.options.labelFontColor}`,
	};

	return (
		<div {...useBlockProps.save()}>
			<div
				className="wpopus-count-down-wrapper"
				data-countDown={attributes.countDownDate}
				style={{ ...countDownStyle }}
			>
				<span className="expired"></span>
				<ul className="wpopus-count-down">
					<li>
						<span className="value days"></span>
						<span className="label">{__("Days", "wpopus")}</span>
					</li>
					<li>
						<span className="value hours"></span>
						<span className="label">{__("Hours", "wpopus")}</span>
					</li>
					<li>
						<span className="value minutes"></span>
						<span className="label">{__("Minutes", "wpopus")}</span>
					</li>
					<li>
						<span className="value seconds"></span>
						<span className="label">{__("Seconds", "wpopus")}</span>
					</li>
				</ul>
			</div>
		</div>
	);
}
